import { ApiDocumentTypes } from "../../shared/documentTypes";

/** What the policy reads from a viewer's file arguments. */
export interface FileCacheSubject {
    /** The owning document's type, which the Documents host threads through. */
    documentType?: string;
    file: { documentType?: string };
    /** A synthetic source with no durable cache identity. */
    disableFileCache?: boolean;
}

/**
 * A shop drawing never enters the durable file cache (OPFS, the native cache, the cloud document
 * store): a package is private to the person, those caches are the org's. The loader and the
 * prefetch check this themselves, so a caller that skips the viewer's policy is covered too.
 */
export function isShopDrawingFile(file: { documentType?: string }): boolean {
    return file.documentType === ApiDocumentTypes.ShopDrawing;
}

/**
 * Whether the open file is a shop drawing: the owning document's type, else the file's own, or
 * the shop review tool hosting the viewer (`review`). The review gate, elements scoping and the
 * cache policy all read this one answer.
 */
export function isShopDrawingContext(args: FileCacheSubject, reviewHosted: boolean): boolean {
    return (
        reviewHosted ||
        args.documentType === ApiDocumentTypes.ShopDrawing ||
        isShopDrawingFile(args.file)
    );
}

/**
 * Whether the viewer's bytes (the open, Compare's copy, the neighbor prefetch) stay out of the
 * durable file cache (`LoadFileOptions.disableCache`): a shop context, or a source with no durable
 * identity (`disableFileCache`).
 */
export function shouldBypassFileCache(args: FileCacheSubject, reviewHosted: boolean): boolean {
    return !!args.disableFileCache || isShopDrawingContext(args, reviewHosted);
}
